import { BulkResizeImage } from "../../types";

export const getRotationOperation = (image: BulkResizeImage, value: number) =>
    ({
        name: "rotate",
        value: {
            rotation: value,
            direction:
                value === 0
                    ? image.rotate.rotation === 270 || image.rotate.rotation === -90
                        ? "clock-wise"
                        : "counter-clock-wise"
                    : value > image.rotate.rotation
                      ? "clock-wise"
                      : "counter-clock-wise",
            flip: {
                horizontal: image.flip.horizontal,
                vertical: image.flip.vertical,
            },
        },
    }) as const;
